import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";

const SystemUserCity = (props) => {
  const { systemUserCity } = props;
  const { t } = useTranslation();
  const style = Style();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t("city")}
          validationMessage={props.errors?.systemUserCity?.message}
          id="systemUserCity"
          placeholder={t("enter_city")}
          name="systemUserCity"
          noRequired
          inputDefaultValue={systemUserCity}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("systemUserCity")}
        />
      </Stack>
    </>
  );
};

export default SystemUserCity;
